import React from "react";
import ReactDOM from "react-dom";
import "./external/prism.css";
import "./external/prism.js";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("app-root"));
